export const PROCESS = 'process';
export const EXAMINE = 'examine';
export const AXIOM_SCANS_TODAY = 'axiom-scans-today';
export const ARTIFACT_STATS = 'artifact-stats';
export const JIRA_METRICS = 'jira-metrics';



// WEBPACK FOOTER //
// src/helpers/telemetry.js